// IMPORTS
	import wixWindow from 'wix-window';

// FUNCTIONS
 // Page
	$w.onReady(function () {
		if (wixWindow.formFactor === "Desktop") $w("#text28").hide();
	});